import api from "../config/api";

const DashboardApi = {
  get() {
    return api.get("dashboard");
  }
};

export default DashboardApi;
